"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_list_ul_gray_png_1 = __importDefault(require("images/sprites/ui/icons_list_ul_gray.png"));
var MessageListButton = function (props) { return (react_1.default.createElement("div", { className: "unreadRequestWindow-Header_MessageListButtonWrapper", onClick: props.onClickMessageListButton },
    react_1.default.createElement("img", { src: icons_list_ul_gray_png_1.default, alt: "LIST", className: "unreadRequestWindow-Header_MessageListButtonIcon lazyload" }),
    react_1.default.createElement("span", { className: "unreadRequestWindow-Header_MessageListButtonText" }, "\u4E00\u89A7"))); };
exports.default = MessageListButton;
